import { render, staticRenderFns } from "./ExportDeck.vue?vue&type=template&id=b8747ece&scoped=true&"
import script from "./ExportDeck.vue?vue&type=script&lang=js&"
export * from "./ExportDeck.vue?vue&type=script&lang=js&"
import style0 from "./ExportDeck.vue?vue&type=style&index=0&id=b8747ece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8747ece",
  null
  
)

export default component.exports